'use client';

import dynamic from 'next/dynamic';
import useListicleImagesModal from 'src/hooks/useListicleImagesModal';
import useGalleryImage from 'src/hooks/useGalleryImage';

const ImageGalleryModal = dynamic(() => import('../gallery/ImageGalleryModal'), {ssr: false});

type Props = {
  list: HumboList;
};

const ListicleImageModalWrapper = ({list}: Props) => {
  const {galleryImageId, galleryPlaceId, closeGallery, replaceGalleryImage} = useGalleryImage();

  const {place} = useListicleImagesModal(list, galleryPlaceId);

  if (!galleryImageId) return null;

  return (
    <ImageGalleryModal
      placeId={place?._id}
      placeName={place?.name || ''}
      countryName={place?.countryName || ''}
      onClose={closeGallery}
      initialImages={place?.images || []}
      activeImageId={galleryImageId}
      setActiveImageId={replaceGalleryImage}
    />
  );
};

export default ListicleImageModalWrapper;
